import { Lazyload } from 'vant'

export default {
  install(Vue) {
    Vue.use(Lazyload, {
      lazyComponent: true,
    })
  },
}
